export default "__VITE_ASSET__DgHbAf5v__"